import { Language } from "../../model/Language.js";
import { Pano } from "../Pano.js";
import { BaseControl, ControlPosition } from "./BaseControl.js";

export class ControlLanguage extends BaseControl {
    constructor(pano: Pano) {
        super(pano);

        this.pano.addButton(
            {
                text: Language.current === "de" ? "EN" : "DE",
                position: ControlPosition.RIGHT,
                tooltip: Language.resolve("Sprache ändern", "Change language"),
                onInit: (item) => {
                    e5.FullscreenUtil.onChange.add((fullscreen) => {
                        item.active = fullscreen;
                    });
                },
                onClick: (item) => {
                    const url = e5.Url.params.set("lang", Language.current === "de" ? "en" : "de");
                    window.open(url, "_self");
                }
            }
        );
    }
}